<template>
  <div class="addpersonInfo">
    <div class="top">
      <el-button type="primary" plain size="small" @click="back">
        返回
      </el-button>
    </div>
    <div class="content clearfix">
      <div class="left">
        <img :src="join1" class="join1" /> <br />
        <img :src="addp" class="addp" /> <br />
        <img :src="join2" class="join2" />
      </div>
      <div :class="showType=='invite'? 'rightInvite': 'rightAdd'">
        <el-form ref="form" :model="form" :inline="true" label-width="120px" size="small">
          <div class="my-table">
            <div v-if="showType=='invite'" class="my-title fl">填写手机号码，邀请指定用户加入企业</div>
            <div v-else class="my-title fl">填写账号，添加指定用户加入企业</div>
            <div v-for="(item, $index) in form.list" :key="$index" class="clear" style="margin-top:10px;">
              <device-info :index="$index" :device-info="item" :list="form.list" :type="1"
                @removeComponent="removeComponent" @addComponent="addComponent"></device-info>
            </div>
          </div>
        </el-form>
        <div class="submitReportBox" :style="showType=='invite'? 'margin-right: 86px;': 'margin-right: 53px;'">
          <el-button v-if="showType=='invite'" :loading="lodinging" type="primary" size="small" @click="submitReport('form')">
            确认邀请
          </el-button>
          <el-button v-else :loading="lodinging" type="primary" size="small" @click="submitReport('form')">确认添加</el-button>
        </div>
      </div>
    </div>
    <el-dialog v-if="professionDialogVisible" v-dialogDrag :visible.sync="professionDialogVisible"
      :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handlePofessionClose" title="邀请成功"
      custom-class="profession-dialog" width="500px">
      <span>
        <p style="text-align: center;">已将邀请链接以短信的形式发送至受邀用户</p>
        <p style="text-align: center;">您还可以复制邀请链接后以其他方式发送至用户</p>
        <p style="text-align: center;margin-top:20px">
          <el-button type="primary" size="small" @click="confirmAddSpec">复制邀请链接</el-button>
        </p>
      </span>
    </el-dialog>
    <Vcode :show="isShow" :canvas-width="349" :canvas-height="209" class="vue-puzzle-vcodeone" @success="onSuccess"
      @close="onclose" />
  </div>
</template>

<script>
import deviceInfo from "@/CommonDP/components/invitePeople";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import Vcode from "vue-puzzle-vcode";
import { mapState } from "vuex";
import { baseUrlWeb } from "@/CommonDP/utils";
import registerService from "@/CommonDP/service/register-service";
export default {
  name: "AddpersonInfo",
  components: {
    deviceInfo,
    Vcode
  },
  data() {
    var telephone1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("手机号格式错误!"));
      } else {
        this.repeat = callback;
        this.repeat2 = value;
        this.querymo();
      }
    };
    var neiwaibu2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择人员类别"));
      } else {
        callback();
      }
    };
    var userName2 = (rule, value, callback) => {
      if (value === "") {
        // callback(new Error("请输入账号"));
      } else {
        var encoded = encodeURI(value);
        var params = {
          phone: encoded
        };
        if (!this.form.list[this.currentIndex].disabledUserName) {
          registerService.userexists(params).then((res) => {
            if (res.data !== 0) {
              callback(new Error("该账号已经注册"));
            } else {
              callback();
            }
          });
        } else {
          callback();
        }
      }
    };
    var name2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入姓名"));
      } else {
        callback();
      }
    };
    return {
      form: {
        list: [
          {
            phone: "",
            neiwaibu: "",
            bumen: "",
            bumenid: "",
            userName: "", // 账号
            name: "", // 账号
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              userName1: { trigger: "change", validator: userName2 },
              name1: { trigger: "change", validator: name2 }
            },
            disabledName: true,
            disabledUserName: true
          }
        ]
      },
      form1: {
        list: [
          {
            phone: "", // 手机号
            neiwaibu: "", // 人员类别 内外部
            bumen: "", // 部门名称
            bumenid: "", // 部门id
            userName: "", // 账号
            name: "", // 账号
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              userName1: { trigger: "change", validator: userName2 },
              name1: { trigger: "change", validator: name2 }
            },
            disabledName: true,
            disabledUserName: true
          }
        ]
      },
      lodinging: false,
      professionDialogVisible: false,
      lianjie: "",
      isShow: false, // 验证码模态框是否出现
      datalist: [],
      join1: require("@/CommonDP/assets/addpersonInfo/join1.png"),
      addp: require("@/CommonDP/assets/addpersonInfo/addp.png"),
      join2: require("@/CommonDP/assets/addpersonInfo/协同小助手.png"),
      repeat: "",
      repeat2: "",
      formDataList: [],
      showType: "",
      currentIndex: 0
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    const { showType } = this.$route.query;
    this.showType = showType;
  },
  methods: {
    back() {
      this.$router.push({ name: "personInfo" });
    },
    addComponent(index) {
      this.currentIndex = index;
      var ii = index + 1;
      var ll = this.form.list.length;
      if (ll === ii) {
        var telephone1 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入手机号"));
          } else if (!/^1[3-9]\d{9}$/.test(value)) {
            callback(new Error("手机号格式错误!"));
          } else {
            this.repeat = callback;
            this.repeat2 = value;
            this.querymo();
          }
        };
        var neiwaibu2 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择人员类别"));
          } else {
            callback();
          }
        };
        var userName2 = (rule, value, callback) => {
          if (value === "") {
            // callback(new Error("请输入账号"));
          } else {
            var encoded = encodeURI(value);
            var params = {
              phone: encoded
            };
            if (!this.form.list[this.currentIndex].disabledUserName) {
              registerService.userexists(params).then((res) => {
                if (res.data !== 0) {
                  callback(new Error("该账号已经注册"));
                } else {
                  callback();
                }
              });
            } else {
              callback();
            }
          }
        };
        var name2 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入姓名"));
          } else {
            callback();
          }
        };
        this.form.list.push({
          phone: "",
          neiwaibu: "",
          bumen: "",
          bumenid: "",
          userName: "", // 账号
          name: "", // 账号
          rules: {
            telephone: { trigger: "change", validator: telephone1 },
            neiwaibu1: { trigger: "change", validator: neiwaibu2 },
            userName1: { trigger: "change", validator: userName2 },
            name1: { trigger: "change", validator: name2 }
          },
          disabledName: true,
          disabledUserName: true
        });
      }
    },
    async querymo() {
      var encoded = encodeURI(this.repeat2);
      var pilots = this.form.list;
      const rebels = pilots.filter((pilot) => pilot.phone === encoded);
      if (rebels.length >= 2) {
        this.repeat(new Error("手机号不能重复"));
      } else {
        registerService.userGetUserByPhone(encodeURI(this.repeat2)).then((res) => {
          this.form.list[this.currentIndex].name = "";
          this.form.list[this.currentIndex].userName = "";
          if (res.data) {
            this.form.list[this.currentIndex].name = res.data.name;
            this.form.list[this.currentIndex].userName = res.data.username;
            this.form.list[this.currentIndex].disabledName = !!res.data.name;
            this.form.list[this.currentIndex].disabledUserName = !!res.data.username;
          } else {
            this.form.list[this.currentIndex].disabledName = false;
            this.form.list[this.currentIndex].disabledUserName = false;
          }
          this.repeat();
        });
      }
    },
    removeComponent(index) {
      this.form.list.splice(index, 1);
    },
    async submitReport(formName) {
      this.lianjie = "";
      const phones = this.form.list.filter((item) => item.phone !== "");
      const neiwaibus = this.form.list.filter((item) => item.neiwaibu !== "");
      // const userName = this.form.list.filter((item) => item.userName !== "");
      const name = this.form.list.filter((item) => item.name !== "");
      if (phones.length || neiwaibus.length || name.length) {
        this.formDataList = [];
        for (var i = 0; i < this.form.list.length; i++) {
          if (this.showType === "invite") {
            if (this.form.list[i].phone) {
              if (!this.form.list[i].neiwaibu) {
                this.$refs.form.validateField("list." + i + ".neiwaibu");
              } else if (!/^1[3-9]\d{9}$/.test(this.form.list[i].phone)) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else {
                var obj5 = {
                  phone: this.form.list[i].phone,
                  isExternal: this.form.list[i].neiwaibu,
                  deptIds: this.form.list[i].bumenid
                };
                this.formDataList.push(obj5);
              }
            } else if (this.form.list[i].neiwaibu) {
              if (!this.form.list[i].phone) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!/^1[3-9]\d{9}$/.test(this.form.list[i].phone)) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else {
                var ttt1 = {
                  phone: this.form.list[i].phone,
                  isExternal: this.form.list[i].neiwaibu,
                  deptIds: this.form.list[i].bumenid
                };
                this.formDataList.push(ttt1);
              }
            }
          } else {
            if (this.form.list[i].userName) {
              if (!this.form.list[i].phone) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!/^1[3-9]\d{9}$/.test(this.form.list[i].phone)) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!this.form.list[i].name) {
                this.$refs.form.validateField("list." + i + ".name");
              } else if (!this.form.list[i].neiwaibu) {
                this.$refs.form.validateField("list." + i + ".neiwaibu");
              } else {
                var obj = {
                  userName: this.form.list[i].userName || this.form.list[i].name,
                  name: this.form.list[i].name,
                  isExternal: this.form.list[i].neiwaibu,
                  deptIds: this.form.list[i].bumenid,
                  phone: this.form.list[i].phone
                };
                if (!this.form.list[this.currentIndex].disabledUserName) {
                  var encoded = encodeURI(this.form.list[i].userName);
                  var params = {
                    phone: encoded
                  };
                  const res = await registerService.userexists(params);
                  if (res.data !== 0) {
                    this.$refs.form.validateField("list." + i + ".userName");
                  } else {
                    this.formDataList.push(obj);
                  }
                } else {
                  this.formDataList.push(obj);
                }
              }
            } else if (this.form.list[i].phone) {
              if (!/^1[3-9]\d{9}$/.test(this.form.list[i].phone)) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!this.form.list[i].name) {
                this.$refs.form.validateField("list." + i + ".name");
              } else if (!this.form.list[i].neiwaibu) {
                this.$refs.form.validateField("list." + i + ".neiwaibu");
              } else {
                var obj2 = {
                  userName: this.form.list[i].userName || this.form.list[i].phone,
                  name: this.form.list[i].name,
                  isExternal: this.form.list[i].neiwaibu,
                  deptIds: this.form.list[i].bumenid,
                  phone: this.form.list[i].phone
                };
                this.formDataList.push(obj2);
              }
            } else if (this.form.list[i].name) {
              if (!this.form.list[i].phone) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!/^1[3-9]\d{9}$/.test(this.form.list[i].phone)) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!this.form.list[i].neiwaibu) {
                this.$refs.form.validateField("list." + i + ".neiwaibu");
              } else {
                var obj3 = {
                  userName: this.form.list[i].userName || this.form.list[i].phone,
                  name: this.form.list[i].name,
                  isExternal: this.form.list[i].neiwaibu,
                  deptIds: this.form.list[i].bumenid,
                  phone: this.form.list[i].phone
                };
                this.formDataList.push(obj3);
              }
            } else if (this.form.list[i].neiwaibu) {
              if (!this.form.list[i].phone) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!/^1[3-9]\d{9}$/.test(this.form.list[i].phone)) {
                this.$refs.form.validateField("list." + i + ".phone");
              } else if (!this.form.list[i].name) {
                this.$refs.form.validateField("list." + i + ".name");
              } else {
                var obj4 = {
                  userName: this.form.list[i].userName || this.form.list[i].phone,
                  name: this.form.list[i].name,
                  isExternal: this.form.list[i].neiwaibu,
                  deptIds: this.form.list[i].bumenid,
                  phone: this.form.list[i].phone
                };
                this.formDataList.push(obj4);
              }
            }
          }
        }
        if (this.formDataList.length >= 1) {
          this.datalist = this.formDataList;
          if (this.showType === "invite") {
            this.isShow = true;
          } else {
            this.addOnSuccess();
          }
        }
      } else {
        this.$message({
          duration: 1000,
          message: "最少加一人",
          type: "warning"
        });
      }
    },
    addOnSuccess() {
      this.lodinging = true;
      var params = {
        enterpriseId: this.enterpriseId,
        userList: this.datalist
      };
      systemPersonService
        .enterpriseAddUser(params)
        .then((res) => {
          if (res.data === "添加成功!") {
            this.$message.success(`${res.data}`);
            this.form = this.form1;
            this.$nextTick(() => {
              this.$refs["form"].resetFields();
            });
          } else {
            this.$message.warning(`${res.data}`);
          }
          this.lodinging = false;
        })
        .catch(() => {
          this.lodinging = false;
        });
    },
    onSuccess() {
      this.isShow = false;
      this.lodinging = true;
      var params = {
        enterpriseId: this.enterpriseId,
        userList: this.datalist
      };
      systemPersonService
        .enterpriseGeteInviCode(params)
        .then((res) => {
          if (res.result === "0") {
            this.professionDialogVisible = true;
            this.lianjie = res.data;
            this.lodinging = false;
            this.form = this.form1;
            this.$nextTick(() => {
              this.$refs["form"].resetFields();
            });
          }
        })
        .catch(() => {
          this.lodinging = false;
        });
    },
    handlePofessionClose() {
      this.professionDialogVisible = false;
    },
    confirmAddSpec() {
      var code = "";
      code = baseUrlWeb() + "/joinEnterprise?code=" + this.lianjie;
      this.$copyText(code).then((res) => {
        this.professionDialogVisible = false;
        this.$message.success("链接复制成功！");
      });
    },
    qingkong() {
      this.form.list = [];
      var telephone1 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入手机号"));
        } else if (!/^1[3-9]\d{9}$/.test(value)) {
          callback(new Error("手机号格式错误!"));
        } else {
          this.repeat = callback;
          this.repeat2 = value;
          this.querymo();
        }
      };
      var neiwaibu2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请选择人员类别"));
        } else {
          callback();
        }
      };
      var userName2 = (rule, value, callback) => {
        if (value === "") {
          // callback(new Error("请输入账号"));
        } else {
          var encoded = encodeURI(value);
          var params = {
            phone: encoded
          };
          if (!this.form.list[this.currentIndex].disabledUserName) {
            registerService.userexists(params).then((res) => {
              if (res.data !== 0) {
                callback(new Error("该账号已经注册"));
              } else {
                callback();
              }
            });
          } else {
            callback();
          }
        }
      };
      var name2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入姓名"));
        } else {
          callback();
        }
      };
      this.form.list.push({
        phone: "",
        neiwaibu: "",
        bumen: "",
        bumenid: "",
        userName: "", // 账号
        name: "", // 账号
        rules: {
          telephone: { trigger: "change", validator: telephone1 },
          neiwaibu1: { trigger: "change", validator: neiwaibu2 },
          userName1: { trigger: "change", validator: userName2 },
          name1: { trigger: "change", validator: name2 }
        },
        disabledName: true,
        disabledUserName: true
      });
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    onclose() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.addpersonInfo {
  height: calc(100% - 96px);
  min-width: 1580px;
  .top {
    height: 57px;
    line-height: 57px;
    border-bottom: 1px solid #d3d9e8c4;
    padding-left: 18px;
  }
  .content {
    background: #f4f5fa;
    border-radius: 4px;
    margin-left: 18px;
    margin-right: 18px;
    height: 100%;
    margin-top: 19px;
  }
  .my-table .btn-table {
    left: 28px;
    width: calc(100% - 28px);
  }
  .el-button--small {
    width: auto;
  }
  .my-form .el-input__inner,
  .my-table .el-input__inner {
    width: 160px;
    height: 30px;
    line-height: 30px;
  }
  .detail-info .el-input__inner {
    width: 480px;
  }
  .el-textarea__inner {
    width: 625px;
  }
  .el-form-item__content {
    height: 40px;
  }
  .left {
    float: left;
    .join1 {
      margin-top: 147px;
      margin-left: 136px;
    }
    .addp {
      margin-top: 73px;
      margin-left: 61px;
    }
    .join2 {
      margin-top: 40px;
      margin-left: 198px;
    }
  }
  .rightAdd {
    float: right;
    width: 1000px;
    height: 100%;
    overflow-x: auto;
    /deep/ .el-input__inner {
      width: 180px !important;
    }
    /deep/ .el-form-item {
      margin-bottom: 15px;
      .userNameStyle {
        input {
          padding-right: 49px !important;
        }
      }
    }
  }
  .rightInvite {
    float: right;
    margin-left: 100px;
    width: 852px;
    height: 100%;
    overflow-x: auto;
    /deep/ .el-input__inner {
      width: 246px !important;
    }
    /deep/ .el-form-item {
      margin-bottom: 15px;
    }
  }
  .clearfix:after {
    /* 正常浏览器 清除浮动 */
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix {
    *zoom: 1; /* zoom 1 就是ie6 清除浮动的方法 * 是ie7以下的版本所识别 */
  }
  .my-title {
    font-size: 18px;
    margin-top: 45px;
    margin-bottom: 20px;
  }
  .submitReportBox {
    text-align: right;
  }
}
</style>
<style>
.vue-puzzle-vcodeone {
  z-index: 9999 !important;
}
</style>
